<div class="net-worth-widget" [class.net-worth-widget--small]="size === 'small'" [class.editmodecheck]="isEditMode"
    (click)="openModal()">
    <div class="net-worth-widget__header">
        <div class="net-worth-widget__header-content">
            <div class="net-worth-widget__title">{{ title }}</div>
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
                    class="net-worth-widget__edit-icon-container" cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                    <div class="net-worth-widget__edit-icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <div class="net-worth-widget__content">
        <div class="net-worth-widget__value-section">
            <div class="net-worth-widget__current-value">{{ currentValue }}</div>
            <div class="net-worth-widget__trend-container">
                <div class="net-worth-widget__trend-row">
                    <div class="net-worth-widget__trend-value">{{ trendValue }}</div>
                    <div class="net-worth-widget__trend-icon-wrapper">
                        <img class="net-worth-widget__trend-icon" src="assets/icons/widget/net-worth-icon.svg"
                            alt="arrow-up">
                    </div>
                </div>
                <div class="net-worth-widget__trend-label">{{ trendLabel }}</div>
            </div>
        </div>

        <div class="net-worth-widget__chart-container">
            <div class="net-worth-widget__chart">
                <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType">
                </canvas>
            </div>
        </div>
    </div>
</div>